import { combineEpics } from 'redux-observable';
import auth from './auth';
import client from './client';
import homeSummary from './homeSummary';
import poiCount from './poiCount';
import homeOrganisations from './homeOrganisations';
import categories from './categories';
import prospectsToWatch from './prospectsToWatch';
import whereYourCustomersHaveBeen from './whereYourCustomersHaveBeen';
import insightsSummary from './footfall/insightsSummary';
import insightsFootfall from './footfall/insightsFootfall';
import biggestMovers from './biggestMovers';
import insightsDailyAverages from './footfall/insightsDailyAverages';
import insightsFootfallOverTime from './footfall/insightsFootfallOverTime';
import insightsPercentage from './footfall/insightsPercentage'
import insightsRepeatVsUnique from './footfall/insightsRepeatVsUnique';
import insightsPoiCount from './footfall/insightsPoiCount'
import downloadAudience from './downloadAudience';
import clientError from './clientError';
import boundaries from './boundaries';
import fetchAccountOverview from './account/fetchAccountOverview';
import fetchAccountList from './account/fetchAccountList';
import fetchAccountPermissions from './account/fetchAccountPermissions';
import fetchPartnerAccounts from './account/fetchPartnerAccounts';
import updateAccount from './account/updateAccount';
import createAccount from './account/createAccount';
import resetPassword from './account/resetPassword';
import resetPasswordSuccess from './account/resetPasswordSuccess';
import requestPasswordResetEmail from './account/requestPasswordResetEmail'
import deleteAccount from './account/deleteAccount';
import changePartnerAccountOwner from './account/changePartnerAccountOwner';
import assignReportsToPartnerAccount from './account/assignReportsToPartnerAccount';
import deleteLinkedPartnerAccount from './account/deleteLinkedPartnerAccount';
import createPartnerAccount from './account/createPartnerAccount';
import associateRolesWithAccount from './account/associateRolesWithAccount';
import updatePersonalDetails from './account/updatePersonalDetails';
import pois from './pois';
import mobileAppsList from './mobileAppsList';
import serverStatusCheck from './account/serverStatusCheck'
//import travel past
import travelPastSummary from './travelPast/travelPastSummary';
import travelPastPoiCount from './travelPast/travelPastPoiCount';
import travelPastDailyAverages from './travelPast/travelPastDailyAverages';
import travelPastOverTime from './travelPast/travelPastOverTime';
import travelPastPois from './travelPast/travelPastPois';
import travelPastRepeatDevices from './travelPast/travelPastRepeatDevices';
import downloadTravelPast from './travelPast/downloadTravelPast'
//import home insight
import homeInsightsHeatmap from './homeInsights/homeInsightsHeatmap';
import homeInsightsSummary from './homeInsights/homeInsightsSummary';
import homeInsightsLocations from './homeInsights/homeInsightsLocations';
import homeInsightsMostPoi from './homeInsights/homeInsightsMostPoi';
import homeInsightsElectorial from './homeInsights/homeInsightsElectorial';
import homeInsightsSuburbInfo from './homeInsights/homeInsightsSuburbInfo';
import homeInsightsBrandAffinity from './homeInsights/homeInsightsBrandAffinity';
import homeInsightsWorkLocations from './homeInsights/homeInsightsWorkLocations';
import downloadHomeInsights from './homeInsights/downloadHomeInsights';
//import work insight
import workInsightsHeatmap from './workInsights/workInsightsHeatmap';
import workInsightsSummary from './workInsights/workInsightsSummary';
import workInsightsLocations from './workInsights/workInsightsLocations';
import workInsightsMostPoi from './workInsights/workInsightsMostPoi';
import workInsightsSuburbInfo from './workInsights/workInsightsSuburbInfo';
import workInsightsBrandAffinity from './workInsights/workInsightsBrandAffinity';
import workInsightsLocationTypes from './workInsights/workInsightsLocationTypes';
import workInsightsHomeLocations from './workInsights/workInsightsHomeLocations';
//import brand Affinity
import brandsReport from './brandAffinity/brandsReport';
import categoriesReport from './brandAffinity/categoriesReport';
import topPoisBrand from './brandAffinity/topPoisBrand';
import topPoisCategory from './brandAffinity/topPoisCategory'
import organisationList from './brandAffinity/organisationList';
import subcategoriesList from './brandAffinity/subcategoriesList';
import downloadBrandAffinity from './brandAffinity/downloadBrandAffinity';
import summaryCard from './brandAffinity/summaryCard'
//import mobile devices
import downloadMobileDevices from './mobileDevices/downloadMobileDevices';
import mobileApplication from './mobileDevices/mobileApplication';
import mobileDevicesSummary from './mobileDevices/mobileDevicesSummary';
import mobileDevicesReport from './mobileDevices/mobiledevicesReport';
import mobileNetworkReport from './mobileDevices/mobileDevicesNetwork';
//import Audience builder
import fetchAudiencePreview from './audience/fetchAudiencePreview';
import createAudience from './audience/createAudience';
import downloadAudienceBuilder from './audience/downloadAudienceBuilder';
import fetchIntegrations from './audience/fetchIntegrations';
import sendAudienceIntegrationJob from './audience/sendAudienceIntegrationJob';

export default combineEpics(
  auth,
  client,
  homeSummary,
  poiCount,
  homeOrganisations,
  serverStatusCheck,
  categories,
  prospectsToWatch,
  whereYourCustomersHaveBeen,
  insightsSummary,
  insightsFootfall,
  insightsPercentage,
  insightsPoiCount,
  insightsRepeatVsUnique,
  biggestMovers,
  insightsDailyAverages,
  insightsFootfallOverTime,
  downloadAudience,
  clientError,
  travelPastSummary,
  travelPastPoiCount,
  travelPastDailyAverages,
  travelPastOverTime,
  travelPastPois,
  travelPastRepeatDevices,
  downloadTravelPast,
  fetchAccountOverview,
  fetchAccountList,
  fetchAccountPermissions,
  fetchPartnerAccounts,
  updateAccount,
  createAccount,
  resetPassword,
  resetPasswordSuccess,
  requestPasswordResetEmail,
  deleteAccount,
  changePartnerAccountOwner,
  assignReportsToPartnerAccount,
  deleteLinkedPartnerAccount,
  createPartnerAccount,
  associateRolesWithAccount,
  updatePersonalDetails,
  requestPasswordResetEmail,
  boundaries,
  homeInsightsHeatmap,
  homeInsightsSummary,
  homeInsightsLocations,
  homeInsightsMostPoi,
  homeInsightsElectorial,
  homeInsightsSuburbInfo,
  homeInsightsBrandAffinity,
  homeInsightsWorkLocations,
  downloadHomeInsights,
  workInsightsHeatmap,
  workInsightsSummary,
  workInsightsLocations,
  workInsightsMostPoi,
  workInsightsSuburbInfo,
  workInsightsBrandAffinity,
  workInsightsLocationTypes,
  workInsightsHomeLocations,
  pois,
  mobileAppsList,
  brandsReport,
  categoriesReport,
  topPoisBrand,
  topPoisCategory,
  organisationList,
  subcategoriesList,
  downloadBrandAffinity,
  summaryCard,
  downloadMobileDevices,
  mobileApplication,
  mobileDevicesSummary,
  mobileDevicesReport,
  mobileNetworkReport,
  fetchAudiencePreview,
  createAudience,
  downloadAudienceBuilder,
  fetchIntegrations,
  sendAudienceIntegrationJob
);
